import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import { isFunction } from '@utiljs/is';

var TableCell = /*#__PURE__*/function (_React$Component) {
  _inherits(TableCell, _React$Component);

  var _super = _createSuper(TableCell);

  function TableCell() {
    var _this;

    _classCallCheck(this, TableCell);

    _this = _super.apply(this, arguments);

    _this.handleClick = function (e) {
      var _this$props = _this.props,
          onCellClick = _this$props.onCellClick,
          columnKey = _this$props.columnKey;
      if (onCellClick) onCellClick(columnKey, e);
    };

    return _this;
  }

  _createClass(TableCell, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (nextProps.columnValue !== this.props.columnValue) return true;
      if (nextProps.align !== this.props.align) return true;
      if (nextProps.render || this.props.render) return true;
      if (nextProps.render && nextProps.record !== this.props.record) return true;
      return false;
    }
  }, {
    key: "getColumnStyle",
    value: function getColumnStyle() {
      var style = {};
      var _this$props2 = this.props,
          styl = _this$props2.style,
          align = _this$props2.align;
      style = styl || style;
      if (align) style.textAlign = align || 'left';
      return style;
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props3 = this.props,
          columnValue = _this$props3.columnValue,
          record = _this$props3.record,
          index = _this$props3.index,
          render = _this$props3.render;
      if (render) return /*#__PURE__*/React.createElement("span", null, render(columnValue, record, index));
      return /*#__PURE__*/React.createElement("span", null, columnValue);
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          onCellClick = _a.onCellClick,
          columnKey = _a.columnKey,
          columnValue = _a.columnValue,
          render = _a.render,
          record = _a.record,
          index = _a.index,
          align = _a.align,
          fullRender = _a.fullRender,
          cellClassName = _a.cellClassName,
          props = __rest(_a, ["onCellClick", "columnKey", "columnValue", "render", "record", "index", "align", "fullRender", "cellClassName"]);

      var clx = isFunction(cellClassName) ? cellClassName(index, _Object$assign({
        key: columnKey,
        value: columnValue
      }, props)) : cellClassName;

      if (fullRender) {
        return fullRender(_Object$assign(_Object$assign({}, this.props), {
          key: columnKey,
          value: columnValue
        }));
      }

      return /*#__PURE__*/React.createElement("td", _Object$assign({}, props, {
        className: clx,
        style: this.getColumnStyle(),
        onClick: this.handleClick
      }), this.renderContent());
    }
  }]);

  return TableCell;
}(React.Component);

export { TableCell as default };